import { render, staticRenderFns } from "./ColorGalleryCard.vue?vue&type=template&id=01e07e7e&"
import script from "./ColorGalleryCard.vue?vue&type=script&lang=js&"
export * from "./ColorGalleryCard.vue?vue&type=script&lang=js&"
import style0 from "./ColorGalleryCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports